import {
  fetch_retry_post,
  downloadFile,
  fetch_retry_get,
  fetch_retry_put,
} from "../redux/actions/ApiManager";
import { getEnv } from "../enviroment";
import { AUTO_PROVISIONING_CLIENT } from "../common/constants/constants"
const { base } = getEnv();

// save new condition
const createOrUpdateCondition = async (payload, client) => {
  try {
    let response = await fetch_retry_post(
      `${base}/condition-builder/condition/create/${client}`,
      payload
    );
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

// get conditions list
const getConditionsList = async (payload, client) => {
  try {
    let response;
    if (client == AUTO_PROVISIONING_CLIENT.PROHANCE) {
      response = await fetch_retry_post(
        `${base}/auto-provisioning/provisioning/get/${client}`,
        payload
      );
    } else {
      response = await fetch_retry_post(`${base}/auto-provisioning/provisioning/get/${client}/${payload.datatype}`, payload);
    }
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

// get conditions details from role id
const getConditionDetails = async (payload, client) => {
  try {
    let response = await fetch_retry_get(
      `${base}/auto-provisioning/details/get/${client}/${payload}`
    );
    let resp = await response;
    if (resp && (resp.status === 200 || resp.status === 201)) {
      return { success: true, data: resp.data };
    } else {
      return { success: false, message: resp.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

// get snapshot data by filters
const getSnapshotFilteredData = async (payload, client) => {
  try {
    let response = await fetch_retry_get(
      `${base}/auto-provisioning/details/getSnapshotData/${client}/${payload}`
    );
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

// export prohance file
const exportProhanceFile = async () => {
  try {
    let fileName = "PROHANCE_FILE";
    let response = await fetch_retry_post(`${base}/auto-provisioning/export/prohanceFile`);
    if (response.status === 200 || response.status === 201) {
      return { success: true };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

const getConditionDropdownList = async (payload) => {
  try {
    let response = await fetch_retry_get(
      `${base}/auto-provisioning/condition/value/get/${payload}`
    );
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

const getFilterListBYid = async (client, payload) => {
  try {
    let response = await fetch_retry_get(
      `${base}/auto-provisioning/criteria/get/${client}/${payload}`
    );
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

const getRoleListBYid = async (client, conditionId, roleName) => {
  try {
    let response = await fetch_retry_get(
      `${base}/auto-provisioning/criteria/get/${client}/${conditionId}/${roleName}`
    );
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};
const getFilterRolesList = async (client, payload) => {
  try {
    let response = await fetch_retry_get(
      `${base}/auto-provisioning/cronJobDetails/get/role/${client}`
    );
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

const saveRoleFilterBYid = async (client, conditionId, payload) => {
  try {
    let response = await fetch_retry_post(
      `${base}/condition-builder/filter/create/${client}/${conditionId}`, payload
    );
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};
const postFilterList = async (client, id, payload) => {
  try {
    let response = await fetch_retry_post(
      `${base}/condition-builder/filter/create/${client}/${id}`,
      payload
    );
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

// get logs list
const getLogDetailsList = async (payload, jobName) => {
  try {
    let response;
    response = await fetch_retry_post(
      `${base}/auto-provisioning/logs/list/${jobName}`,
      payload
    );
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

// get log details by job id
const getCronLogDetails = async (payload) => {
  try {
    let response;
    response = await fetch_retry_post(
      `${base}/auto-provisioning/logs/details`,
      payload
    );
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};


// get cron job details
const getCronJobDetails = async (jobName) => {
  try {
    let response = await fetch_retry_get(
      `${base}/auto-provisioning/cronJobDetails/get/${jobName}`
    );
    let resp = await response;
    if (resp && (resp.status === 200 || resp.status === 201)) {
      return { success: true, data: resp.data };
    } else {
      return { success: false, message: resp.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

const updateCronJobDetails = async (payload, client) => {
  try {
    let response = await fetch_retry_post(
      `${base}/auto-provisioning/cronJobDetails/update/${client}`,
      payload
    );
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

// get provisioning Type
const getProvisionTypes = async () => {
  try {
    let response = await fetch_retry_get(
      `${base}/auto-provisioning/getProvisioningTypes`
    );
    let resp = await response;
    if (resp && (resp.status === 200 || resp.status === 201)) {
      return { success: true, data: resp.data };
    } else {
      return { success: false, message: resp.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};
// get cron job details
const getProvisionDataType = async (provisionType) => {
  try {
    let response = await fetch_retry_get(
      `${base}/auto-provisioning/getProvisioningDataTypes/${provisionType}`
    );
    let resp = await response;
    if (resp && (resp.status === 200 || resp.status === 201)) {
      return { success: true, data: resp.data };
    } else {
      return { success: false, message: resp.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

const getGlobalJobList = async (payload) => {
  try {
    let response = await fetch_retry_post(
      `${base}/global_job/list`,
      payload
    );
    let resp = await response;
    if (resp && (resp.status === 200 || resp.status === 201)) {
      return { success: true, data: resp.data };
    } else {
      return { success: false, message: resp.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

const updateJobStatus = async (payload) => {
  try {
    let response = await fetch_retry_put(
      `${base}/global_job/${payload?.jobId}/changeStatus`,
      { isDeleted: payload?.isDeleted }
    );
    let resp = await response;
    if (resp && (resp.status === 200 || resp.status === 201)) {
      return { success: true, data: resp.data };
    } else {
      return { success: false, message: resp.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

const runJobNow = async (payload) => {
  try {
    let response = await fetch_retry_post(
      `${base}/global_job/runJobNow`,
      { ...payload }
    );
    let resp = await response;
    if (resp && (resp.status === 200 || resp.status === 201)) {
      return { success: true, data: resp.data };
    } else {
      return { success: false, message: resp.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

const runJobNowByProvisionId = async (provisionId) => {
  try {
    let response = await fetch_retry_post(
      `${base}/global_job/runJobNow/${provisionId}`
    );
    let resp = await response;
    if (resp && (resp.status === 200 || resp.status === 201)) {
      return { success: true, data: resp.data };
    } else {
      return { success: false, message: resp.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

const getJobById = async (jobId) => {
  try {
    let response = await fetch_retry_get(
      `${base}/global_job/${jobId}`
    );
    let resp = await response;
    if (resp && (resp.status === 200 || resp.status === 201)) {
      return { success: true, data: resp.data };
    } else {
      return { success: false, message: resp.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

const createJob = async (payload) => {
  try {
    let response = await fetch_retry_post(
      `${base}/global_job/create`,
      payload
    );
    let resp = await response;
    if (resp && (resp.status === 200 || resp.status === 201)) {
      return { success: true, data: resp.data };
    } else {
      return { success: false, message: resp.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

const updateJob = async (payload) => {
  try {
    let response = await fetch_retry_post(
      `${base}/global_job/update`,
      payload
    );
    let resp = await response;
    if (resp && (resp.status === 200 || resp.status === 201)) {
      return { success: true, data: resp.data };
    } else {
      return { success: false, message: resp.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

const revokeToken = async (payload) => {
  try {
    let response = await fetch_retry_post(`${base}/global_job/revoke/client_access/${payload.cronId}/${payload.clientId}`, payload);
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

const generateToken = async (payload) => {
  try {
    let response = await fetch_retry_post(`${base}/global_job/generate/client_access/${payload.cronId}`, payload);
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

const getHostnameList = async (payload) => {
  try {
    let response = await fetch_retry_get(`${base}/global_job/hostname/list`, payload);
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

const getFetchableColumns = async (payload) => {
  try {
    let response = await fetch_retry_get(`${base}/global_job/fetchable/columns`, payload);
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

const updateAlternateEmailStatus = async (payload) => {
  try {
    let response = await fetch_retry_put(
      `${base}/global_job/${payload?.jobId}/alternate_email`,
      { status: payload?.isAlternateEmail }
    );
    let resp = await response;
    if (resp && (resp.status === 200 || resp.status === 201)) {
      return { success: true, data: resp.data };
    } else {
      return { success: false, message: resp.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};
const changeAlternateEmailStatus = async (payload) => {
  try {
    let response = await fetch_retry_put(
      `${base}/auto-provisioning/change/alternate_email/${payload?.jobId}`,
      { status: payload?.isAlternateEmail }
    );
    let resp = await response;
    if (resp && (resp.status === 200 || resp.status === 201)) {
      return { success: true, data: resp.data };
    } else {
      return { success: false, message: resp.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};
// for download invalid records
const downloadInvalidRecords = async (payload) => {
  try {
    let response = await fetch_retry_get(
      `${base}/auto-provisioning/invalid_email/${payload}`,
      
    );
    let resp = await response;
    if (resp && (resp.status === 200 || resp.status === 201)) {
      return { success: true, data: resp.data };
    } else {
      return { success: false, message: resp.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};
const domainFilterUpdate = async (payload) => {
  try {
    let response = await fetch_retry_put(
      `${base}/auto-provisioning/update/domain_filter/${payload?.id}`,
      { domainFilters: payload?.alternateEmailProvisioningValue },
    );
    if (response && (response.status === 200 || response.status === 201)) {
      return { success: true, data: response.data };
    } else {
      return { success: false, message: response.data?.message || 'Update failed' };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.response?.data?.message || 'Update failed due to an error' };
  }
};
const getGlobalJobHostnameList = async (payload) => {
  try {
    let response = await fetch_retry_get(
      `${base}/global_job/hostname/list`,
      payload
    );
    let resp = await response;
    if (resp && (resp.status === 200 || resp.status === 201)) {
      return { success: true, data: resp.data };
    } else {
      return { success: false, message: resp.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

export const autoProvisioningService = {
  createOrUpdateCondition,
  getConditionsList,
  getConditionDetails,
  getSnapshotFilteredData,
  exportProhanceFile,
  postFilterList,
  getConditionDropdownList,
  getFilterListBYid,
  getLogDetailsList,
  getCronJobDetails,
  updateCronJobDetails,
  getCronLogDetails,
  getProvisionTypes,
  getProvisionDataType,
  getGlobalJobList,
  updateJobStatus,
  getJobById,
  createJob,
  updateJob,
  getFilterRolesList,
  saveRoleFilterBYid,
  getRoleListBYid,
  runJobNow,
  runJobNowByProvisionId,
  revokeToken,
  generateToken,
  getHostnameList,
  getFetchableColumns,
  updateAlternateEmailStatus,
  changeAlternateEmailStatus,
  downloadInvalidRecords,
  getGlobalJobHostnameList,
  domainFilterUpdate
};
